import { Component, type ReactNode } from 'react';

interface EditorErrorBoundaryProps {
  fallback: ReactNode;
  children: ReactNode;
}

interface EditorErrorBoundaryState {
  hasError: boolean;
}

export class EditorErrorBoundary extends Component<EditorErrorBoundaryProps, EditorErrorBoundaryState> {
  state: EditorErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): EditorErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
